import { DollarSign, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Revenue() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <DollarSign className="h-16 w-16 text-muted-foreground/40 mb-4" />
      {/* Spacing lives on the sibling, so the h1 itself stays margin-free and
          identical to every other page heading. */}
      <h1 className="text-xl sm:text-2xl font-bold tracking-tight">Revenue</h1>
      <p className="text-muted-foreground mt-2 mb-6">Revenue tracking is coming soon. View your payment data on Stripe.</p>
      <Button variant="outline" asChild>
        <a href="https://dashboard.stripe.com" target="_blank" rel="noopener noreferrer">
          <ExternalLink className="mr-2 h-4 w-4" /> Open Stripe Dashboard
        </a>
      </Button>
    </div>
  );
}
